import React from 'react';

function Certificate({ name, counter, onClick }) {
  const today = new Date();
  const month = today.getMonth() + 1;
  return (
    <div className="certificateContent answerContent">
      <div className="certificateWrapper">
        <div className="certificateInner">
          <p className="resultStamp">
            <img src={'assets/img/stamp-result-04.png'} alt="たいへんよくできました" className="stampResult" />
          </p>
          <p className="certificateTitle">
            <img src={'assets/img/ttl-certificate.png'} alt="表彰状" className="ttlCertificate" />
          </p>
          <div className="nameRow">
            <p className="certificateName">{name}</p>
            <p>
              <img src={'assets/img/txt-sama.png'} alt="さま" className="txtSama" />
            </p>
          </div>
          <p className="certificateText">
            <img src={'assets/img/txt-certificate-01.png'} alt="おめでとうございます!!植物ふしぎ検定満点です!!" className="txtCertificate" />
          </p>
          <p className="certificateDate">{today.getFullYear() + '年' + month + '月' + today.getDate() + '日'}</p>
        </div>
      </div>
    </div>
  );
}

export default Certificate;
